export class ValueMustMatchValidationError {
  constructor(public referenceValue: unknown) {}
}
